// extracted by mini-css-extract-plugin
module.exports = {"root":"column_root__VIgYZ"};